module.exports = __webpack_public_path__ + "static/media/delete.dbda56a0.svg";